export const isSafari = (userAgentOverride?: string): boolean => {
  if (typeof window === "undefined" || !window.navigator?.userAgent) {
    return false;
  }
  const userAgent = userAgentOverride ?? window.navigator.userAgent;
  const requiredSubstrings = ["Safari", "Version"];
  const excludedSubstrings = [
    "Chrome",
    "Chromium",
    "Edg",
    "OPR",
    "CriOS",
    "FxiOS"
  ];

  const hasRequired = requiredSubstrings.every((substring) =>
    userAgent.includes(substring)
  );
  const lacksExcluded = excludedSubstrings.every(
    (substring) => !userAgent.includes(substring)
  );

  return hasRequired && lacksExcluded;
};

export const isIOS = (userAgentOverride?: string): boolean => {
  if (typeof window === "undefined" || !window.navigator?.userAgent) {
    return false;
  }
  const ua = userAgentOverride ?? window.navigator.userAgent;
  return (
    /iPad|iPhone|iPod/.test(ua) ||
    (ua.includes("Mac") && "ontouchend" in document)
  );
};

export const isDesktop = (userAgentOverride?: string): boolean => {
  if (typeof window === "undefined" || !window.navigator?.userAgent) {
    return false;
  }
  const ua = userAgentOverride ?? window.navigator.userAgent;
  return !/Mobi|Tablet|iPad|iPhone|iPod/.test(ua);
};
